import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=3f197709&scoped=true&"
import script from "./MessageTemplates.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=3f197709&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f197709",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VCol,VRow,VTooltip})
